// extracted by mini-css-extract-plugin
export default {"hasSubrow":"PivotBodyRow_hasSubrow__JSd7D"};